/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesAuthOauthUserInfoResponse interface.
 */
export function instanceOfFxIdWebFeaturesAuthOauthUserInfoResponse(value) {
    if (!('Sub' in value) || value['Sub'] === undefined)
        return false;
    if (!('Id' in value) || value['Id'] === undefined)
        return false;
    if (!('Email' in value) || value['Email'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesAuthOauthUserInfoResponseFromJSON(json) {
    return FxIdWebFeaturesAuthOauthUserInfoResponseFromJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthOauthUserInfoResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Sub': json['sub'],
        'Id': json['id'],
        'Email': json['email'],
    };
}
export function FxIdWebFeaturesAuthOauthUserInfoResponseToJSON(json) {
    return FxIdWebFeaturesAuthOauthUserInfoResponseToJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthOauthUserInfoResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'sub': value['Sub'],
        'id': value['Id'],
        'email': value['Email'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesAuthOauthUserInfoResponse.js.map